/**
 * Search Field component
 *
 * @module components/search-field
 */

import Component from './component';
import utils from '../utils';

export default (($, /* eslint-disable */ window, undefined /* eslint-enable */) => {
  'use strict';

  /**
   * ComponentName component class
   */
  class SearchField extends Component {
    /**
     * Constructor
     */
    constructor(element, options = {}) {
      super(element, options);
      this.name = 'search-field';
    }

    /**
     * Main initializer
     * 
     * @returns void
     */
    init() {
      const el = this.element;

      if (el.hasClass(this.initializedClass)) {
        // only need to initialize this component once
        return;
      }

      // mark as initialized
      el.addClass(this.initializedClass);

      this.elInput = $(SearchField.selectors.searchInput, el).first();
      this.elClearBtn = $(SearchField.selectors.clearButton, el);

      el.on('click', SearchField.selectors.clearButton, () => {        
        this.elInput.val('').trigger('input')[0].focus();
        this.element.trigger('cleared');
      });

      this.updateState = utils.debounce(this._updateState.bind(this), 60);
      el.on('input', SearchField.selectors.searchInput, () => {
        this.updateState();
      });

      this.updateState();
    }

    _updateState() {
      window.requestAnimationFrame(() => {
        this.element.toggleClass('-has-input', (this.elInput.val() !== ''));
      });
    }
  }

  SearchField.selectors = {
    searchInput: 'input[type="search"]',
    clearButton: '.search-field--clear'
  };

  return SearchField;
})(jQuery, window);